import React from 'react';
import Logo_w from '../images/logomenu_w.png'

export default function Idle({cur_time}){  

    let date = new Date()  
    let h = date.getHours()  
    let m = date.getMinutes()  
    h = (h < 10) ? '0' + h : h  
    m = (m < 10) ? '0' + m : m    
    cur_time = h + ':' + m

    let idIntervals = setInterval(function () {  
        date = new Date()  
        h = date.getHours()  
        m = date.getMinutes()  
        h = (h < 10) ? '0' + h : h  
        m = (m < 10) ? '0' + m : m    
        cur_time = h + ':' + m
        if(document.getElementById('time')) document.getElementById('time').innerHTML = cur_time;
    }, 3000);


    return(
        <div>
            <div className='idle_logo'>
                <img src={Logo_w} width="100%"/>
            </div>
            <div className='idle'>
                <span id="time">{cur_time}</span>
            </div>
        </div>
    )
}